"use client";

import Link from "next/link";
import { useTranslation } from "../hooks/useTranslation";
import { HowToPlay } from "./HowToPlay";

interface LandingPageProps {
  session?: any; // define proper type if available
  login?: (formData: FormData) => Promise<void>;
}

export function LandingPage({ session, login }: LandingPageProps) {
  const { t } = useTranslation();

  return (
    <>
    <main className="min-h-screen bg-white text-gray-900 my-6 md:m-6 lg:m-10 rounded-2xl overflow-hidden" style={{ boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.08)" }}>
      {/* Hero Section */}
      <section className="w-full">
        <div className="w-full relative">
          <div className="flex justify-center min-h-[300px]">
            <img 
              src="https://ocnc-fantasy.s3.eu-west-1.amazonaws.com/files/prono-rtbf-hero.jpg"
              alt="Voorspel en win"
              className="w-full object-cover rounded-t-2xl"
            />
          </div>
          <div
            className="absolute inset-0 rounded-t-2xl pointer-events-none"
            style={{
              background:
                "linear-gradient(180deg, rgba(0, 118, 169, 0.2) 0%, rgba(0, 62, 99, 0.8) 100%)",
            }}
          />
          {/* Text Overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
              <div>{t('home.heroTitle1')}</div>
              {t('home.heroTitle2') ? <div>{t('home.heroTitle2')}</div> : null}
            </h1>
            <p className="text-sm md:text-sm lg:text-base text-white mt-4 md:mt-6 max-w-xl md:max-w-2xl lg:max-w-3xl font-medium px-2 py-1 md:px-3 md:py-1.5 rounded-lg">
              {t('home.heroSubtitle')}
            </p>
            <div className="mt-6 md:mt-8">
              <Link
                href="/fantasy/predictions"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#FDC300] px-6 py-3 md:px-8 md:py-4 text-sm md:text-base font-bold text-[#000000] transition-all duration-200 hover:bg-yellow-300 active:scale-95 shadow-md"
              >
                <span>{t('home.playNow')}</span>
                <svg 
                  className="w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 transition-transform duration-300 group-hover:translate-x-1" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* How to Play Section */}
      <HowToPlay />

      
    </main>
    {/* Bottom CTA Section */}
    <section className="w-full">
    <div className="max-w-5xl mx-auto px-4">
      <div className="bg-[var(--bet-red)] rounded-2xl md:rounded-3xl px-8 md:px-12 lg:px-16 py-12 md:py-16 lg:py-20">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8">
          {/* CTA Text */}
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white text-center md:text-left md:flex-1">
            {t('home.ctaTitle')}
          </h2>
          
          {/* CTA Button */}
          <div className="shrink-0">
            <Link
              href="/fantasy/predictions"
              className="inline-flex items-center justify-center rounded-full bg-[#FDC300] px-8 py-3 md:px-10 md:py-4 text-base md:text-lg font-bold text-[#000000] transition-all duration-200 hover:bg-yellow-300 active:scale-95 shadow-md whitespace-nowrap"
            >
              {t('home.ctaButton')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
  </>
  );
}

